import { Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';

import { AdminInfoMailFacade } from './admin-info-mail.facade';
import {
  InfoMailAttachment,
  InfoMailState,
  InfoMailTemplateDto,
} from '@models/resources/info-mail.model';

/**
 * Dummy-Variante des Info-Mail-Bereichs (User-Feedback 2026-08).
 * In-Memory-Zustand, damit der Screen im `?dataSource=dummy`-Modus
 * komplett bedienbar bleibt.
 */
@Injectable()
export class DummyAdminInfoMailFacade implements AdminInfoMailFacade {
  private subject: string | null = 'Informationen zu Ihrer Anfrage';
  private body: string | null =
    'Sehr geehrte Kundin, sehr geehrter Kunde,\n\nanbei erhalten Sie weiterführende Informationen.';

  private attachments: InfoMailAttachment[] = [
    { id: 1, filename: 'produktbroschuere.pdf', size_bytes: 482_133 },
  ];

  private nextId = 2;
  private agbUploadedAt: string | null = null;
  private sampleOrderUploadedAt: string | null = null;

  get(): Observable<InfoMailState> {
    return this.respond();
  }

  saveTemplate(dto: InfoMailTemplateDto): Observable<InfoMailState> {
    this.subject = dto.subject;
    this.body = dto.body;
    return this.respond();
  }

  uploadAttachment(file: File): Observable<InfoMailState> {
    this.attachments = [
      ...this.attachments,
      { id: this.nextId++, filename: file.name, size_bytes: file.size },
    ];
    return this.respond();
  }

  deleteAttachment(id: number): Observable<InfoMailState> {
    this.attachments = this.attachments.filter((a) => a.id !== id);
    return this.respond();
  }

  uploadAgb(_file: File): Observable<InfoMailState> {
    this.agbUploadedAt = new Date().toISOString();
    return this.respond();
  }

  uploadSampleOrder(_file: File): Observable<InfoMailState> {
    this.sampleOrderUploadedAt = new Date().toISOString();
    return this.respond();
  }

  private respond(): Observable<InfoMailState> {
    return of({
      subject: this.subject,
      body: this.body,
      attachments: [...this.attachments],
      agb_uploaded_at: this.agbUploadedAt,
      sample_order_uploaded_at: this.sampleOrderUploadedAt,
    }).pipe(delay(120));
  }
}
